import useWantedJobPosting from '~hooks/query/company/useWantedJobPosting';

import Card from '../Card';
import CompanyCard from './CompanyCard';
import { useCompanyInfo } from './hooks';
import JobPostingCard from './JobPostingCard';
import * as S from './style';

interface Props {
  companyId: string;
  isRecommended: boolean;
}

export default function WantedJobPostingInfo({ companyId, isRecommended }: Props) {
  const { data: wantedJobPosting } = useWantedJobPosting(companyId);
  const { sectionTitle, rightCardHeader, linkMore } = useCompanyInfo({
    wantedJobPosting,
    PK_NM_HASH: companyId,
  });

  if (isRecommended !== wantedJobPosting?.is_recommended) {
    return null;
  }

  return (
    <Card
      sectionId='watned-job-posting'
      title={sectionTitle}
      rightCardHeader={rightCardHeader}
      style={{ marginTop: '16px' }}>
      {wantedJobPosting?.is_recommended && (
        <S.CompanyCardWrapper>
          <CompanyCard
            PK_NM_HASH={companyId}
            companyName={wantedJobPosting.company.name}
            isRecommended={wantedJobPosting.is_recommended}
            location={wantedJobPosting.company.location}
            logoThumbnail={wantedJobPosting.company.logo_thumb_img}
            linkMore={linkMore as string}
          />
        </S.CompanyCardWrapper>
      )}
      <S.Contents>
        <S.Poster>
          {wantedJobPosting?.company.title_img && (
            <img src={wantedJobPosting?.company.title_img} alt='' />
          )}
        </S.Poster>
        <S.JobList length={wantedJobPosting?.company.jobs.length}>
          {wantedJobPosting?.company.jobs.slice(0, 4).map((job) => (
            <JobPostingCard
              key={job.id}
              position={job.position}
              reward={job.reward}
              href={`https://www.wanted.co.kr/wd/${job.id}`}
              PK_NM_HASH={companyId}
              name={wantedJobPosting.company.name}
              is_recommended={wantedJobPosting.is_recommended}
            />
          ))}
        </S.JobList>
      </S.Contents>
    </Card>
  );
}
